import React from "react";
import { Hero } from "../components/home/Hero";
import { ServicesSection } from "../components/home/ServicesSection";
import { AboutSection } from "../components/home/AboutSection";
import { ProcessSection } from "../components/home/ProcessSection";
import { TestimonialsSection } from "../components/home/TestimonialsSection";
import { FaqSection } from "../components/home/FaqSection";
import { CtaSection } from "../components/home/CtaSection";
export function Home() {
  return <>
      <Hero data-id="element-216" data-mp="24gim4gan7gpe" />
      <ServicesSection data-id="element-217" data-mp="24i3fw3p4uvm7" />
      <AboutSection data-id="element-218" data-mp="24hk6xchgnhkb" />
      <ProcessSection data-id="element-219" data-mp="24j4ugi5cy08o" />
      <TestimonialsSection data-id="element-220" data-mp="29gdaac319s6r" />
      <FaqSection data-id="element-221" data-mp="29f26wddi2mg6" />
      <CtaSection data-id="element-222" data-mp="29ek57182jg0v" />
    </>;
}